// ***** SHOP CUSTOM CONFIG START *****

export const CONFIG_HEADER = {
    hasNavigation: false,
    hasLanguages: false,
    hasLogo: true,
    hasTitle: true,
    hasContextMenu: true
}

export const CONFIG_LOGIN = {
    hasAgeConfirm: false,
    isFindIdLink: false,
    hasInfoText: false,
    hasUsernameConfirm: true
}

export const CONFIG_PAYMENT = {
    defaultPaymentProvider: 'hup',
    paymentProviders: {
        adyen: 'adyen',
        hup: 'hup'
    },
    isOpeningInNewTab: true
}

export const CONFIG_FOOTER = {
    hasAdditionalLinks: true
}

export const API = {
    url: 'https://test-shishi-api.imperiax.org/'
};

export let ENV = 'test';
export let ENV_ADYEN = 'test';
export let ADYEN_RETURN_URL = 'https://test-shishi.imperiax.org/checkout-result';
export let ADYEN_CLIENT_KEY = 'test_FESOQUDCKJC2XIPASSO3BQGY74PDQVG6';
// get the ENV from the .env file(because it has different env when building)
ENV = process.env.REACT_APP_ENV;
if (!ENV) {
    ENV = 'test';
}
if (ENV === 'dev') {
    API.url = '/';
    // API.url = '//shishi-memberstest-api.6waves.com/';
    ADYEN_RETURN_URL = 'https://dev-shishi2.imperiax.info/checkout-result';
    ADYEN_CLIENT_KEY = 'test_FESOQUDCKJC2XIPASSO3BQGY74PDQVG6';
    ENV_ADYEN = 'test';
}
if (ENV === 'test') {
    // API.url = 'https://test-shishi-api.imperiax.org/';
    API.url = '/';
    ADYEN_RETURN_URL = 'https://test-shishi.imperiax.org/checkout-result';
    ADYEN_CLIENT_KEY = 'test_FESOQUDCKJC2XIPASSO3BQGY74PDQVG6';
    ENV_ADYEN = 'test';
}
if (ENV === 'stagingTest') {
    API.url = '//shishi-memberstest-api.6waves.com/';
    ADYEN_RETURN_URL = '//shishi-memberstest.6waves.com/checkout-result';
    ADYEN_CLIENT_KEY = 'test_FESOQUDCKJC2XIPASSO3BQGY74PDQVG6';
    ENV_ADYEN = 'test';
}
if (ENV === 'stagingLive') {
    API.url = '//shishi-memberstest-api.6waves.com/';
    ADYEN_RETURN_URL = '//shishi-memberstest.6waves.com/checkout-result';
    ADYEN_CLIENT_KEY = 'live_WX6PVIYN6VDN7CZH2DWAGNG7QQUQLJXZ';
    ENV_ADYEN = 'live';
}
if (ENV === 'live') {
    API.url = '//shishi-members-api.6waves.com/';
    ADYEN_RETURN_URL = '//shishi-members.6waves.com/checkout-result';
    ADYEN_CLIENT_KEY = 'live_WX6PVIYN6VDN7CZH2DWAGNG7QQUQLJXZ';
    ENV_ADYEN = 'live';
}

export const MOBILE_VIEW_BREAKPOINT = 1024;

export const MOBILE_VIEW_TABLET = 768;

export const DEFAULT_MENUS = [];

/**
 * Generates age options for the age confirmation dropdown (18-150)
 */
const getPossibleYears = () => {
    const minYears = 18;
    const maxYears = 150;
    const years = [];
    for (let i = minYears; i <= maxYears; i++) {
        years.push({value: i, label: i});
    }
    return years;
}

export const ageInputData = {
    years: getPossibleYears()
}

export const MIN_YEARS_TO_PURCHASE = 18;

export const TAX_INCLUDED_TEXT = '（税込）';

export const FREE_TEXT = '無料獲得';

export const NO_CAROUSEL_LAYOUT = 1;

export const SUPPORT_MAIL = 'sample@sample.com'

export const HAS_SEARCH_BAR = true;

export const HAS_CATEGORY_FILTER = false;

export const HAS_CATEGORY_NAVIGATION = true;

// ***** SHOP CUSTOM CONFIG END   *****
